export default __webpack_public_path__ + "static/media/questions-desktop.fa9866ca.png";